import React from "react"
import MetaTags from "react-meta-tags"
import { Row, Col, Card, CardBody } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import EnptReportGenerateComponent from "../../components/EnptReportGenerate"

const EnptReportGenerate = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>ENPT Report Generate</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs title="ENPT" breadcrumbItem="Generate Report" />
          <EnptReportGenerateComponent />
        </div>
      </div>
    </React.Fragment>
  )
}

export default EnptReportGenerate

